if (!customElements.get('revv-flavor-spin')) {
  customElements.define('revv-flavor-spin', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.visible = false;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => this.sync(), {signal:this.controller.signal});
      this.sync();
    }
    sync() { this.toggleAttribute('data-paused', !this.visible || document.hidden); }
    disconnectedCallback() { this.observer.disconnect(); this.controller.abort(); }
  });
}
